export const blogData = [
  {
    id: 'InstantFlowsPitch',
    title: 'The AI Startup Validation Challenge',
    image: 'pitch-card.png',
    category: 'AI Pitch Instantflows',
    date: '29 July 2025',
    authors: ['George Gittins']
  },
  {
    id: 'LinguisticsToBusiness',
    title: 'Navigating AI as a Non-Techie: My Leap from Linguistics to Business',
    image: 'linguistics-to-business.png',
    category: 'AI and Business',
    date: '04 August 2025',
    authors: ['Priscille Niakale']
  },
  {
    id: 'understandingInstantFlows',
    title: 'Understanding InstantFlows: How We Generate Reliable AI Automated Survey Responses',
    image: 'understanding-instantflows.jpeg',
    category: 'AI Response Generation Methodology',
    date: '16 July 2025',
    authors: ['George Gittins']
  },
  {
    id: 'aiHumanSurvey', 
    title: 'The Integration of AI and Human Expertise in Survey Response Design',
    image: 'ai-human-survey.jpeg',
    category: 'AI and Human Expertise',
    date: '20 August 2024',
  },
  {
    id: 'aiMarketResearch', 
    title: 'The Rise of AI in Automated Survey Responses: Revolutionizing Insights',
    image: 'ai-market-research.jpeg',
    category: 'AI in Survey Responses',
    date: '22 September 2024',
  },
  {
    id: 'syntheticData',
    title: 'Synthetic Data: The Future of Privacy-Conscious AI Automated Survey Responses',
    image: 'synthetic-data.jpeg',
    category: 'Privacy and Data Protection',
    date: '13 October 2024',
  },
  {
    id: 'instantflowsAiChallenges',
    title: 'InstantFlows: Tackling AI Challenges with Trusted Insights and Solutions',
    image: 'instantflows-ai-challenges.jpeg',
    category: 'AI Solutions',
    date: '13 November 2024',
    authors: ['George Gittins', 'Priscille Niakale'] // Optional
  },
  {
    id: 'realTimeInsights',
    title: 'Real-Time Insights: The Power of AI-Generated Survey Responses',
    image: 'real-time-insights.jpeg',
    category: 'Real-Time Insights',
    date: '02 December 2024',
  },
  {
    id: 'revolutionizingMarketResearch',
    title: 'White Paper: Revolutionizing AI Automated Survey Responses',
    image: 'revolutionizing-market-research.jpeg',
    category: 'Synthetic Data and Generative AI',
    date: '01 July 2025',
  },
  {
    id: 'InstantflowsBreakfast',
    title: 'InstantFlows Breakfast Blog',
    image: 'revolutionizing-market-research.jpeg',
    category: 'Synthetic Data and Generative AI',
    date: '01 July 2025',
  },
];